
const FileIcon = ({ variant = "" }) => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="24" height="24" rx="12" fill={variant === "success" ? "#D1FADF" : "#D1E9FF"} />
            <g clipPath="url(#clip0_1325_8245)">
                <path d="M13.333 6V8.66667C13.333 8.84348 13.4032 9.01305 13.5283 9.13807C13.6533 9.2631 13.8229 9.33333 13.9997 9.33333H16.6663" stroke={variant === "success" ? "#027A48" : "#1849A9"} strokeWidth="0.933333" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M15.333 18H8.66634C8.31272 18 7.97358 17.8595 7.72353 17.6095C7.47348 17.3594 7.33301 17.0203 7.33301 16.6667V7.33333C7.33301 6.97971 7.47348 6.64057 7.72353 6.39052C7.97358 6.14048 8.31272 6 8.66634 6H13.333L16.6663 9.33333V16.6667C16.6663 17.0203 16.5259 17.3594 16.2758 17.6095C16.0258 17.8595 15.6866 18 15.333 18Z" stroke={variant === "success" ? "#027A48" : "#1849A9"} strokeWidth="0.933333" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M10 10H10.6667" stroke={variant === "success" ? "#027A48" : "#1849A9"} strokeWidth="0.933333" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M10 12.6665H14" stroke={variant === "success" ? "#027A48" : "#1849A9"} strokeWidth="0.933333" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M10 15.3335H14" stroke={variant === "success" ? "#027A48" : "#1849A9"} strokeWidth="0.933333" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_1325_8245">
                    <rect width="16" height="16" fill="white" transform="translate(4 4)" />
                </clipPath>
            </defs>
        </svg>

    )
}

export default FileIcon